module.exports = __webpack_public_path__ + "img/fahrradgarage_marbach.e5a5c116.jpg";